import React from 'react'
import Image from 'next/image'

/* blocks */
import Button from '@/atoms/Button/Button'

/* assets */
import Image1 from 'public/assets/images/reason_1.png'
import Image2 from 'public/assets/images/reason_2.png'
import Image3 from 'public/assets/images/reason_3.png'
import { ReactComponent as ArrowLeft } from 'public/assets/icons/arrow-right.svg'

interface Props {
  title?: string
  description?: string
  list: {
    title: string
    description: string
    image?: {
      localFile: string
      alternativeText: string
      height: number
      width: number
    }
  }[]
  cta?: string
  onCtaClick?: () => void
}

const PlatformBenefits: React.FC<Props> = ({
  title,
  description,
  list,
  cta,
  onCtaClick
}) => {
  const defaultImages = [Image1, Image2, Image3]
  return (
    <section>
      <div className="max-desktop-width  |  mx-auto py-12 px-5 lg:px-6 lg:py-22">
        <header
          className="text-center  |  mb-12 mx-auto lg:mb-16"
          style={{ maxWidth: 784 }}
        >
          <h2 className="h3 font-medium  |  mb-4">{title}</h2>
          {description && <p className="text-paragraph-2">{description}</p>}
        </header>
        <div className="grid lg:grid-cols-3  gap-8  text-center">
          {list &&
            list.map((item, index) => {
              return (
                <div key={item.title}>
                  {item.image ? (
                    <div className="max-w-[328px]  |  px-0 mb-12 mx-auto">
                      <Image
                        src={item.image?.localFile}
                        width={item.image?.width}
                        height={item.image?.height}
                        alt={`Reason ${index + 1} graphic`}
                      />
                    </div>
                  ) : (
                    defaultImages && (
                      <div className="max-w-[328px]  |  px-0 mb-12 mx-auto">
                        <Image
                          src={defaultImages[index]}
                          alt={`Reason ${index + 1} graphic`}
                        />
                      </div>
                    )
                  )}
                  <div className="px-4">
                    <h3 className="h5 font-medium  |  mb-4">{item.title}</h3>
                    <p className="text-paragraph-3 text-gray-70  |   max-w-lg  |  mx-auto mb-6">
                      {item.description}
                    </p>
                  </div>
                </div>
              )
            })}
        </div>
        {cta && (
          <div className="flex justify-center  |  mt-8">
            <Button
              className="h5  w-full sm:w-auto"
              icon={<ArrowLeft />}
              size="small"
              onClick={onCtaClick}
            >
              {cta}
            </Button>
          </div>
        )}
      </div>
    </section>
  )
}

export default PlatformBenefits
